import { callAPI } from "../helper/apiUtils";
import { PINNED_ROOMS_MAX } from "../pages/Project/roomDnd";
import { SET_PINNED_ROOMS } from "../store";

export async function persistPinnedRooms(rooms, dispatch) {
  const next = Array.isArray(rooms) ? rooms.slice(0, PINNED_ROOMS_MAX) : [];
  dispatch({ type: SET_PINNED_ROOMS, payload: next });
  try {
    const { data } = await callAPI(
      "/user/pinnedRooms",
      {},
      "PUT",
      { roomIds: next.map((r) => r.id) }
    );
    if (data && data.status && Array.isArray(data.pinnedRooms)) {
      dispatch({ type: SET_PINNED_ROOMS, payload: data.pinnedRooms });
      return data.pinnedRooms;
    }
  } catch (e) {
    /* keep optimistic list */
  }
  return next;
}
